import { create } from 'zustand';

/**
 * Shared "skip this step?" confirm dialog state (StepHeader + StepFooter).
 * Set when the user presses Next on a step whose tools have not been applied.
 * @typedef {{ step: string, toolNames: string[] }} PendingSkip
 */
const useSkipStepStore = create((set) => ({
  /** @type {PendingSkip | null} */
  pending: null,
  setPending: (pending) => set({ pending }),
  clearPending: () => set({ pending: null }),
}));

export default useSkipStepStore;
